import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const StyledSkeleton = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.palette.primary.main,
  highlightColor: props.theme.palette.colors.backgroundgrey,
}))`
  display: flex;
  line-height: 1;
`;